import src from "IMAGE";
export default { src, width: 339, height: 74, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADc3YY42QFB1JCUmayIiI2gpKSqAHSQqaQQ3YnkCO2x/AClKbXwpLTBPGxscRBkZGT0aGhtDGh0fRhAjM0gMIDFBBBoOGWcCf2kAAAAASUVORK5CYII="};
